import { STORAGE_KEYS } from "@/constants";
import { decodeToken } from "@/utils/tokenDecoder";

// Auth entry endpoints legitimately return 401 (wrong OTP / credentials) and must not force a logout.
const AUTH_ENTRY_PATTERN =
  /\/(auth\/(login|mobile-login|send-otp|resend-otp|verify-otp)|superadmin\/(login|register))\b/;

const SESSION_KEYS = [
  STORAGE_KEYS.AUTH_TOKEN,
  STORAGE_KEYS.REFRESH_TOKEN,
  STORAGE_KEYS.USER_DATA,
  STORAGE_KEYS.COMPANY_DATA,
  "auth_token",
  "superAdminToken",
  "tally_selected_company_id",
];

let isRedirecting = false;

/**
 * Returns the token expiry in ms since epoch, or null if the token has no `exp` claim.
 */
export const getTokenExpiry = (token) => {
  const payload = decodeToken(token);
  return payload?.exp ? payload.exp * 1000 : null;
};

export const isTokenExpired = (token) => {
  const expiry = getTokenExpiry(token);
  return expiry !== null && Date.now() >= expiry;
};

export const clearSession = () => {
  try {
    SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    // Safari private mode may block localStorage access.
  }
};

/**
 * Clears the stored session and sends the user to /login. Safe to call many times —
 * parallel failing requests only trigger a single redirect.
 */
export const expireSession = () => {
  clearSession();
  if (isRedirecting || window.location.pathname === "/login") return;
  isRedirecting = true;
  window.location.replace("/login");
};

export const isSessionExpiredError = (error) =>
  error?.response?.status === 401 && !AUTH_ENTRY_PATTERN.test(error?.config?.url || "");
